import { signInWithCustomToken, type User } from "firebase/auth";
import { httpsCallable } from "firebase/functions";
import { auth, functions } from "./firebase.ts";

interface SendAuthEmailRequest {
  email: string;
  type: "login" | "verify";
  requireExistingUser: boolean;
}

interface SendAuthEmailResponse {
  success: boolean;
  isTestAccount?: boolean;
}

interface VerifyOTPRequest {
  email: string;
  code: string;
}

interface VerifyOTPResponse {
  customToken: string;
  isNewUser: boolean;
}

const sendAuthEmailFn = httpsCallable<SendAuthEmailRequest, SendAuthEmailResponse>(
  functions,
  "sendAuthEmail"
);

const verifyOTPFn = httpsCallable<VerifyOTPRequest, VerifyOTPResponse>(
  functions,
  "verifyOTP"
);

export async function requestOtp(email: string): Promise<void> {
  await sendAuthEmailFn({
    email: email.trim().toLowerCase(),
    type: "login",
    requireExistingUser: true,
  });
}

export async function submitOtp(email: string, code: string): Promise<User> {
  const result = await verifyOTPFn({
    email: email.trim().toLowerCase(),
    code: code.trim(),
  });
  const { user } = await signInWithCustomToken(auth, result.data.customToken);
  return user;
}

export function watchAuth(cb: (user: User | null) => void): () => void {
  return auth.onAuthStateChanged(cb);
}

export async function getIdToken(): Promise<string> {
  const user = auth.currentUser;
  if (!user) throw new Error("Not signed in");
  return await user.getIdToken();
}
